import moment from 'moment';

const defaultFormat = process.env.REACT_APP_DATE_TIME_FORMAT || 'YYYY-MM-DD HH:mm:ss';

export default function parseDateTime(date, format = defaultFormat) {
  return moment(date).format(format);
}
